import React from 'react';
export function IdentidadSection() {
  return <section className="bg-[#F5F5F5] py-16 md:py-24 px-4" data-id="element-88">
      <div className="max-w-4xl mx-auto text-center" data-id="element-89">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-90">
          Vender es un negocio
        </h2>

        <div className="space-y-4 text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto leading-relaxed" data-id="element-91">
          <p data-id="element-92">Y los negocios no crecen trabajando más horas.</p>
          <br data-id="element-93" />
          <p className="font-bold text-gray-900" data-id="element-94">
            Crecen cuando sabes dónde poner tu tiempo, tu energía y tu foco.
          </p>
        </div>
      </div>
    </section>;
}